import {
  FeriasService
} from "../../../../services/FeriasService";

export default {
  name: "MilitaresNaoAgendado",

  watch: {
    page: function (val) {
      this.page = val;
      this.pegarMilitaresSemAgendamentoFerias();
    },
  },

  data: () => ({
    headers: [{
      text: "Militar",
      value: "nome",
      width: "10%"
    }, ],

    items: [],
    page: 1,
    pageCount: 1,
    totalItems: 1,
    lastPage:[],
  }),

  async mounted() {
    await this.pegarMilitaresSemAgendamentoFerias();
    // await this.pegarMilitaresSemAgendamentoFerias();
    this.pageCount = this.lastPage;
    this.$forceUpdate();

  },
  methods: {
    confirmAction() {
      this.$emit("confirmAction");
    },

    async pegarMilitaresSemAgendamentoFerias() {
      const filter = new FormData();
      filter.append("page", this.page);
      filter.append("id_unidade", this.$store.state.user.Unidade.id);

      const response = await FeriasService.getFeriasNaoSolicitada(filter);
   
      this.items = response.data;
      this.lastPage = response.last_page;
      this.pageCount = response.last_page;
      this.totalItems = response.total;


    },
  },
};